import axios from "../axios";

const cancelGoogleSecret = async function (accessToken) {
    try {
        const response = await axios.get('/profile/cancelGoogleSecret', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default cancelGoogleSecret;
